<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
/** APIs */
import ReportingGroupApi from '../../api/ReportingGroupApi'
import ReportingUnitApi from '../../api/ReportingUnitApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import ValidationPeriodApi from '../../api/ValidationPeriodApi'
import FormAccessApi from '../../api/FormAccessApi'
import VfeApi from '../../api/VfeApi'
import FormsApi from '../../api/FormsApi'
import UserApi from '../../api/UserApi'
import ActivityLogsApi from '../../api/ActivityLogsApi'
import IssueApi from '../../api/IssueApi'
/** Constants */
import ReportingGroup from '../../constants/ReportingGroup'
import ValidationCardStatus from '../../constants/ValidationCardStatus'
/** UI Components */
import { Collapse } from 'buefy/dist/components/collapse'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Select } from 'buefy/dist/components/select'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Loading } from 'buefy/dist/components/loading'
import { Message } from 'buefy/dist/components/message'
import { Modal } from 'buefy/dist/components/modal'
import { Table,TableColumn } from 'buefy/dist/components/table'
import { Datepicker } from 'buefy/dist/components/datepicker'
import { Timepicker } from 'buefy/dist/components/timepicker'

import Timer from '../../components/TimeRemaining'

import ChangeStatusForm from '../../components/ChangeStatusForm'

const VPERIOD_READY_STATUS = 'Ready';
const VPERIOD_OPEN_STATUS = 'Open';
const VPERIOD_CLOSED_STATUS = 'Closed';
const VCARD_SECTION_LOG = 'Validation Card';
const ALLOWED_ROLE = 'Independent Administrator';
const LIMIT_TO_CHANGE_DEADLINE = 14;
const FORM_COUNT_LIMIT = 4;

export default {
    name : "AdminDashboardView",
    components: {
        'b-collapse' : Collapse,
        'b-checkbox' : Checkbox,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-select' : Select,
        'b-icon' : Icon,
        'b-input' : Input,
		'b-loading' : Loading,
        'b-modal' : Modal,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'b-message' : Message,
        ChangeStatusForm,
        'b-datepicker' : Datepicker,
        'b-timepicker' : Timepicker,
        Timer
    },
	computed : {
		...mapState({
            activeNav : "activeNav",
            profile : "userProfile",
            token : "xOreAuth",
            overallBreakdown: 'overallBreakdown',
            groupStatusBreakdown: 'groupStatusBreakdown'
        }),
        filterByStatus(){
            if (this.selectedExpandedGroup) {
                if (this.selectedExpandedGroup.selectedStatus!=='Pending Validation Card') {
                    if (this.selectedExpandedGroup.topData.length > 0) {
                        return this.selectedExpandedGroup.topData.filter(eu=>{
                            return (eu.validationCardStatus==this.selectedExpandedGroup.selectedStatus)
                        })
                    }
                }
                else {
                    if (this.selectedExpandedGroup.statusBreakdown.length > 0) {
                        let pendingItem = this.selectedExpandedGroup.statusBreakdown.filter(statusData=>{
                            if (statusData.pendingData.length > 0) {
                                statusData.pendingData.forEach(d=>{
                                    d.validationCardStatus = statusData.validationCardStatus;
                                    d.validationCardStatusClass = statusData.validationCardStatusClass;
                                });
                            }
                            return (statusData.validationCardStatus==this.selectedExpandedGroup.selectedStatus)
                        });
                        if (pendingItem.length > 0) {
                            return pendingItem[0].pendingData;
                        }
                    }
                }
            }
            return [];
        },
        gotoFormBtnLabel(){
            if (this.vPeriodForms.length == 0) {
                return 'Add Form'
            }
            return 'Continue'
        },
        gotoFormMsgAction(){
            if (this.vPeriodForms.length == 0) {
                return 'start'
            }
            return 'continue'
        },
        allValidated(){
            let readForClose = false;
            let allZero = true;
            if (this.overallBreakdown) {
                this.overallBreakdown.forEach(statusBreakdown=>{
                    if (statusBreakdown.validationCardStatus!='Validated and Submitted') {
                        if (statusBreakdown.count==0) {
                            allZero = (allZero && true);
                        }
                        else {
                            allZero = (allZero && false);
                        }
                    }
                })
            }
            return allZero;
        },
        deadline(){
            if (!this.dueDate) {
                return false 
            }
            return this.$moment(this.dueDate).format('MMM DD, YYYY HH:mm:ss');
        },
        disableChangeDeadline(){
            if (this.validationPeriod) {
                if (this.validationPeriod.dueDate!=null) {
                    let today =  this.$moment();
                    let deadline = this.$moment(this.validationPeriod.dueDate);
                    let diff = deadline.diff(today, 'days');
                    if (diff <= LIMIT_TO_CHANGE_DEADLINE) {
                        return true;
                    }                    
                    return false;
                }
            }
        },
        readableDeadline(){
            if (this.validationPeriod) {
                if (this.validationPeriod.dueDate!=null) {
                    return this.$moment(this.validationPeriod.dueDate,'YYYY-MM-DD HH:mm:ss').format('lll');//format('MMM. DD, YYYY HH:mm:ss');
                }
            }
            return "";
        },
        dueDateEpoch(){
            if (this.validationPeriod) {
                if (this.validationPeriod.dueDate!=null) {
                    return parseInt(this.$moment(this.validationPeriod.dueDate,'YYYY-MM-DD HH:mm:ss').format('x'),10)
                }
            }
            return null;
        }
    },
    data(){
        return {
            formCountToOpen : FORM_COUNT_LIMIT,
            allEntitiesCount : 0,
            allEntitiesUnitsData : [],
            isLoading : false,
            groupBy: "Ungrouped",
            searchKeyword: "",
            validationStatusLookup : [
                {
                    groupId: 0,
                    status : "No Data Entry"
                },
                {
                    groupId: 1,
                    status : "Data Entry - In Progress"
                },
                {
                    groupId: 2,
                    status : "Ready for Validation"
                },
                {
                    groupId: 3,
                    status : "Validated and Submitted"
                }
            ],
            validationStatusBreakdown : [],
            // groupStatusBreakdown : [],
            // overallBreakdown : [],
            openShowMoreModal : false,
            selectedExpandedGroup : null,

            reportingYearLov : [],
            selectedReportingYear : null,
            forGenerationSelectedRepYear : null,
            selectedEntitiesUnitsForGeneration : [],
            allEntitiesUnitsSelected : false,
            forGenerationData : {
                repEntityIds : [],
                repUnitIds : [],
                'Reporting Entity' : [],
                'Reporting Unit' : []
            },
            showGetStarted : true,
            validationPeriod : null,
            vPeriodForms : [],
            showChangeStatus : false,
            vcardForStatusChange : null,
            loadingOverallBreakdown : false,
            loadingGroupBreakdown : false,
            isFullPage : false,
            openConfirmationForVperiod : false,
            dueDate : null,
            minDate : new Date(this.$moment(new Date()).add(1,'days')),
            showTimeSelection : false,
            dueTime : null,
            minuteInc : 15,
            showAddDeadline : false,
            globalLoading: null,
            selectedRepGroup: null,
            allRepGroups: []
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData",
            setActiveNav : "updateActiveNav",
            setProfile : "updateUserProfile",
            updateValidationEntries: "updateValidationEntries",
            updateOverallBreakdown: 'updateOverallBreakdown',
            updateGroupStatusBreakdown: 'updateGroupStatusBreakdown'
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                if (this.profile) {
                                    if (this.profile.role!=ALLOWED_ROLE) {
                                        this.logOut();
                                        return false
                                    }
                                }
                                // Default call in created
                                this.getAllEntitiesUnits();
                                this.getReportingYearLov();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                });
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },

        getValidationStatus(entity){
            if (this.allValidationEntries.length==0) {
                return "No Data Entry";
            }
            var existing = this.allValidationEntries.filter(entry=>{
                return (entry.reportingEntity==entity)
            });
            if (existing.length==0) {
                return "No Data Entry"
            }
            else {
                return existing[0].validationStatus;
            }
        },
        getValidationStatusTag(entity){
            if (this.allValidationEntries.length==0) {
                return 0;
            }
            var existing = this.allValidationEntries.filter(entry=>{
                return (entry.reportingEntity==entity)
            });
            if (existing.length==0) {
                return 0
            }
            else {
                var groupId = null;
                this.validationStatusLookup.filter(status=>{
                    if (status.status==existing[0].validationStatus) {
                        groupId = status.groupId;
                    }
                })
                return groupId
            }
        },
        getWorkspaceLink(entity,repGroup){
            return '#/preview-workspace?repGroup='+encodeURIComponent(repGroup)+'&repUnit='+encodeURIComponent(entity.reportingEntity);
        },
        getAllEntitiesUnits(){
            this.allEntitiesUnitsData = [];
            ReportingUnitApi.getUnitsEntities()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.allEntitiesUnitsData = response.data;
                    }
                    else {
                        this.promptServerError({response},'ReportingUnit.getUnitsEntities');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingUnit.getUnitsEntities');
            });
        },
        getReportingYearLov(){
            this.isLoading = true;

            this.reportingYearLov = [];
            this.selectedReportingYear = null;
            
            let staticYrs = AppResourceUtil.getRepYrStaticLov();
            // Default reporting year is current year minus 1; or previous year
            let defaultRepYear = parseInt(this.$moment().format('YYYY'),10) - 1;

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (repYearInDb > 0) {
                            try {
                                /* Pre-select the year with data (from DB) */ 
                                this.selectedReportingYear = repYearInDb[0];
                            }
                            catch(yrErr){}
                        }
                        else {
                            this.selectedReportingYear = defaultRepYear;
                        }
                        if (this.selectedReportingYear != null) {
                            this.getValidationPeriod();
                            this.getCreatedForms();
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
                
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getCreatedForms(){
            this.vPeriodForms = [];
            if (!this.selectedReportingYear) {
                return false
            }
            FormsApi.getByYear(this.selectedReportingYear)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.vPeriodForms = response.data;
                    }
                    else {
                        this.promptServerError({response},'Form.getByYear');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.getByYear');
            });
        },
        getValidationPeriod(){
            this.isLoading = true;
            this.showGetStarted = true;
            this.validationPeriod = null;

            ValidationPeriodApi.get({
                reportingYear : this.selectedReportingYear,
                status : ''
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length == 0) {
                            // No validation period
                            this.isLoading = false;
                        }
                        else {
                            this.showGetStarted = false;
                            if (response.data[0]) {
                                this.validationPeriod  = response.data[0];
                                if (this.validationPeriod.vPeriodStatus==VPERIOD_READY_STATUS) {
                                    this.showGetStarted = true;
                                    this.isLoading = false;
                                }
                                else {
                                    this.isLoading = false;
                                    this.getData();
                                }
                            }  
                        }
                    } 
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationPeriod.get');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationPeriod.get');
            })
        },
        getData(calledBy){ 
            /** calledBy has value when called after vcard generation */
            if (this.overallBreakdown.length == 0 || calledBy) {
                this.getOverallStatusBreakdown();   
            }
            else {
                this.getRepGroups();
            }
        },
        getOverallStatusBreakdown(){
            // this.overallBreakdown = [];
            this.loadingOverallBreakdown = true;
            ValidationCardApi.getPerStatus({
                statusList : ValidationCardStatus,
                reportingYear : this.selectedReportingYear
            })
            .then(response=>{
                if (response.data) {
                    this.loadingOverallBreakdown = false;
                    if (!response.data.error) {
                        /** No store implementation */
                        // this.overallBreakdown = response.data;

                        this.updateOverallBreakdown(response.data)
                        this.getRepGroups();
                    }
                    else {
                        this.promptServerError({response},'ValidationCard.getPerStatus');
                    }
                }
            })
            .catch(error=>{
                this.loadingOverallBreakdown = false;
                this.promptServerError(error,'ValidationCard.getPerStatus');
            });
        },
        getRepGroups(){
            // this.loadingGroupBreakdown = true;
            this.showLoading()
            this.selectedRepGroup = null
            this.allRepGroups = []
            ReportingGroupApi.getList()
            .then(response => {
                if (response.data) {
                    if (!response.data.error) {
                        let groups = response.data;
                        let repGroupIds = groups.map(grp=>{
                            return (grp.repGroupId)
                        });
                        this.allRepGroups = groups
                        this.selectedRepGroup = groups[0].reportingGroup
                        this.getGroupStatusBreakdown()
                        // this.getStatusPerRepGroup(repGroupIds,groups);
                        // this.closeLoading()
                    }
                    else {
                        // this.loadingGroupBreakdown = false;
                        this.closeLoading()
                        this.promptServerError({response},'ReportingGroup.getList');
                    }
                }
            })
            .catch(error => {
                // this.loadingGroupBreakdown = false;
                this.closeLoading()
                this.promptServerError(error,'ReportingGroup.getList');
            });
        },
        getGroupStatusBreakdown() {
            if (!this.selectedRepGroup) {
                return false 
            }
            var groupRes = this.allRepGroups.filter(g=>{
                return g.reportingGroup === this.selectedRepGroup
            })
            if (groupRes.length > 0) {
                var groupId = groupRes[0].repGroupId 

                ValidationCardApi.getGroupStatus({
                    reportingYear: this.selectedReportingYear,
                    repGroupId: groupId,
                    repGroupData: [groupRes[0]],
                    statusList: ValidationCardStatus
                })
                .then(response=>{
                    if (response.data) {
                        this.closeLoading()
                        if (!response.data.error) {
                            var alldata = response.data;
                            if (alldata.length > 0) {
                                alldata.forEach(grp=>{
                                    this.$set(grp,'perPage',5);
                                    this.$set(grp,'entityUnitSearchKeyword','');
                                    if (grp.topData.length > 0) {
                                        grp.topData.forEach(t=>{
                                            this.$set(t,'entityUnitLabel',t.reportingUnit ? t.reportingUnit : t.reportingEntity);
                                        });
                                    }
                                });
                            }
                            /** No store implementation */
                            // this.groupStatusBreakdown = alldata;
                            this.updateGroupStatusBreakdown(alldata)
                        }
                        else {
                            this.promptServerError({response},'ValidationCard.getGroupStatus');
                        }
                    }
                })
                .catch(error=>{
                    // this.loadingGroupBreakdown = false;
                    this.closeLoading()
                    this.promptServerError(error,'ValidationCard.getGroupStatus');
                })
            }
        },
        getStatusPerRepGroup(repGroupIds,repGroupData){
            // this.loadingGroupBreakdown = true;
            ValidationCardApi.getStatusPerRepGroup({
                repGroupIds,
                repGroupData,
                statusList :  ValidationCardStatus,
                reportingYear : this.selectedReportingYear
            })
            .then(response=>{
                if (response.data) {
                    this.closeLoading()
                    // this.loadingGroupBreakdown = false;
                    if (!response.data.error) {
                        var alldata = response.data;
                        if (alldata.length > 0) {
                            alldata.forEach(grp=>{
                                this.$set(grp,'perPage',5);
                                this.$set(grp,'entityUnitSearchKeyword','');
                                if (grp.topData.length > 0) {
                                    grp.topData.forEach(t=>{
                                        this.$set(t,'entityUnitLabel',t.reportingUnit ? t.reportingUnit : t.reportingEntity);
                                    });
                                }
                            });
                        }
                        /** No store implementation */
                        // this.groupStatusBreakdown = alldata;
                        this.updateGroupStatusBreakdown(alldata)
                    }
                    else {
                        this.promptServerError({response},'ValidationCard.getStatusPerRepGroup');
                    }
                }
            })
            .catch(error=>{
                // this.loadingGroupBreakdown = false;
                this.closeLoading()
                this.promptServerError(error,'ValidationCard.getStatusPerRepGroup');
            })
        },
        viewEntitiesUnits(grpData,status) {
            // Reset data
            // Revert this to null if the conception of 'validation period' is ommitted
            this.forGenerationSelectedRepYear = this.selectedReportingYear;
            this.selectedEntitiesUnitsForGeneration = [];
            this.allEntitiesUnitsSelected = false;
            // Array of IDs only
            this.forGenerationData.repEntityIds = [];
            this.forGenerationData.repUnitIds = [];
            // Array of objects : related IDs
            this.forGenerationData['Reporting Entity'] = [];
            this.forGenerationData['Reporting Unit'] = [];

            this.openShowMoreModal = true;
            // Filter By Status
            this.selectedExpandedGroup = grpData;
            this.selectedExpandedGroup.selectedStatus = status.validationCardStatus;
        },

        selectGroupBy(grpBy) {
            this.groupBy = grpBy;
        },
        showMore(grpData) {
            // this.openShowMoreModal = true;
            // this.selectedExpandedGroup = ReportingGroup[groupId];
        },
        closeExpandedView(){
            this.openShowMoreModal = false;
            this.selectedExpandedGroup = null;
        },
        selectReportingYear(){
            if (this.selectedReportingYear!=null) {
                this.getValidationPeriod();
                this.getCreatedForms();
            }
        },
        gotoAddForm(){
            this.$router.push({path:"/admin/forms/add?reportingYear="+this.selectedReportingYear});
        },
        checkToCloseOpen(){
            if (this.closeOpenVperiodLabel.match(/close/i)) {
                this.confirmCloseValidationPeriod();
            }
            else {
                this.reopenValidationPeriod();
            }
        },
        confirmCloseValidationPeriod(){
            /*if (!this.allValidated){
                return false;
            }*/
            this.$dialog.confirm({
                title: 'Confirmation',
                message: '<strong>This action will close the reporting for year '+this.selectedReportingYear+'. Companies and/or agencies will NO LONGER be able to input their data for the said year.</strong> Please ensure that ALL companies/agencies have already moved their cards to \'Validated and Submitted\'. <p><br/></p> <p>If there are companies/agencies that still need to input their data, click \'Cancel\'. Otherwise, click \'Close Reporting for '+this.selectedReportingYear+'\'.</p>',
                cancelText: 'Cancel',
                confirmText: 'Close Reporting for '+this.selectedReportingYear,
                type: 'is-success',
                onConfirm: () => {
                    this.closeValidationPeriod();
                }
            })
        },
        closeValidationPeriod(){
            this.isLoading = true;
            // Update validation period in the database
            // This means that companies and agencies are no longer allowed to input their data 
            // for the selected reporting year
            ValidationPeriodApi.update({
                reportingYear : this.selectedReportingYear,
                vPeriodStatus : VPERIOD_CLOSED_STATUS,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                this.isLoading = false;
                if (response.data) {
                    if (!response.data.error &&
                        response.data.isUpdated) {
                        // Go to forms
                        this.selectReportingYear();
                    }
                    else {
                        this.promptServerError({response},'ValidationPeriod.update');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                // Show error 
                this.promptServerError(error,'ValidationPeriod.update');
            });
        },
        reopenValidationPeriod(){
            this.isLoading = true;
            // Update validation period in the database
            // This means that companies and agencies can NOW start inputing their data 
            // for the selected reporting year
            ValidationPeriodApi.update({
                reportingYear : this.selectedReportingYear,
                vPeriodStatus : VPERIOD_OPEN_STATUS,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                this.isLoading = false;
                if (response.data) {
                    if (!response.data.error &&
                        response.data.isUpdated) {
                        // Go to forms
                        this.selectReportingYear();
                    }
                    else {
                        this.promptServerError({response},'ValidationPeriod.update');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                // Show error 
                this.promptServerError(error,'ValidationPeriod.update');
            });
        },
        logActivity(logData) {
            ActivityLogsApi.add(logData)
            .then(response=>{
                // Reset status change models
                this.showChangeStatus = false;
                this.vcardForStatusChange = null;
                
                if (response.data) {
                    if (!response.data.error &&
                        response.data.logId) {
                        // Call init function
                        if (this.selectedReportingYear != null) {
                            this.getValidationPeriod();
                            this.getCreatedForms();
                        }
                    }
                    else {
                        this.promptServerError({response},'ActivityLogs.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ActivityLogs.add');
            });
        },
        refreshData(){
            /** Store implementation */
            this.updateOverallBreakdown([]);
            this.updateGroupStatusBreakdown([]);

            this.isLoading = true;
            this.getValidationPeriod();
            this.getCreatedForms();
            
            // this.getReportingYearLov();
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        searchResults(grpData){
            if (grpData.topData.length == 0)  {
                return grpData.topData;
            }
            if (grpData.entityUnitSearchKeyword.trim()==''){
                return grpData.topData;
            }
            let regExp = new RegExp(grpData.entityUnitSearchKeyword, 'i');
            return grpData.topData.filter(t=>{
                return t.entityUnitLabel.match(regExp);
            });
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            if (this.globalLoading !== null) {
                this.globalLoading.close()
            }
            this.globalLoading = null
        },
        selectGroup () {
            this.showLoading()
            if (this.selectedRepGroup === 'All') {
                var repGroupIds = this.allRepGroups.map(g=>{
                    return g.repGroupId
                })
                this.getStatusPerRepGroup(repGroupIds, this.allRepGroups);
            }
            else {
                this.getGroupStatusBreakdown()
            }
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title no-margin--btm">Dashboard</p>

        <!-- Reporting Year Selection -->
        <div class="base-box--sidepadded margin-left margin-btm--med">
            <div class="columns">
                <div class="column">
                    <div class="field is-grouped">
                        <div class="control">
                            <b-dropdown
                                v-model="selectedReportingYear">
                                <button class="button is-primary is-outlined"
                                    type="button"
                                    slot="trigger">
                                    <template
                                        v-if="selectedReportingYear">
                                        <strong>Reporting Year ({{selectedReportingYear}})</strong>
                                    </template>
                                    <template
                                        v-else>
                                        <strong>Select Reporting Year</strong>
                                    </template>
                                    <b-icon icon="menu-down"></b-icon>
                                </button>

                                <b-dropdown-item
                                    v-for="(year,yearIdx) in reportingYearLov"
                                    v-bind:key="yearIdx"
                                    v-bind:value="year"
                                    v-on:click="selectReportingYear(year)">
                                    <h4>{{year}}</h4>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="control">
                            <button type="button"
                                class="button is-light tooltip is-tooltip-top"
                                data-tooltip="Refresh data"
                                v-on:click="refreshData">
                                <span class="icon">
                                    <i class="fas fa-redo"></i>
                                </span>
                            </button>
                        </div>
                        <div class="control"
                            v-if="readableDeadline!=''"
                            style="padding:0.1rem;">
                            <Timer 
                                :dueDate="dueDateEpoch"/>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        
        <section class="base-box--loading"
            v-if="isLoading">
            <b-loading 
                v-bind:is-full-page="false" 
                v-bind:active.sync="isLoading"
                >
                <b-icon
                    pack="fas"
                    icon="sync-alt"
                    size="is-medium"
                    custom-class="fa-spin">
                </b-icon>
                &nbsp;&nbsp;&nbsp;
                <span class="title is-5">Loading dashboard</span>
            </b-loading>
        </section>

        <section class="section no-padd--top app-view"
            v-if="!isLoading && !showGetStarted && (validationPeriod!=null && validationPeriod.vPeriodStatus!=='Ready')"> 
            
            <b-message 
                type="is-info"
                v-if="validationPeriod && validationPeriod.vPeriodStatus=='Closed'">
                Validation for year {{selectedReportingYear}} is now closed. Companies and agencies are no longer allowed to input their data.
            </b-message>
           
            <div class="section no-padd reporting-group-section hero-metrics-box">
                <section>
                    <b-loading 
                        v-bind:is-full-page="isFullPage" 
                        v-bind:active.sync="loadingOverallBreakdown"
                        >
                        <b-icon
                            pack="fas"
                            icon="sync-alt"
                            size="is-medium"
                            custom-class="fa-spin">
                        </b-icon>
                        &nbsp;&nbsp;&nbsp;
                        <span class="title is-5">Loading overall breakdown..</span>
                    </b-loading>
                </section>
                <div class="level"
                    v-if="overallBreakdown.length > 0 && !loadingOverallBreakdown">
                    <div class="level-item has-text-centered"
                        v-for="(vstatus,vstatusIdx) in overallBreakdown"
                        v-bind:key="vstatusIdx">
                        <div>
                            <p class="heading">{{vstatus.validationCardStatus}}</p>
                            <p class="title"
                                v-bind:class="'vstatus-text--'+vstatusIdx">{{vstatus.count}}</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <section>

                <div class="field is-grouped"
                    style="margin-top:0.6rem;margin-bottom:1.5rem;margin-left:1.35rem;">
                    <div class="control">
                        <b-dropdown
                            v-model="selectedRepGroup">
                            <button class="button is-primary is-outlined"
                                type="button"
                                slot="trigger">
                                <template
                                    v-if="selectedRepGroup">
                                    <strong>{{selectedRepGroup}}</strong>
                                </template>
                                <template
                                    v-else>
                                    <strong>Select Reporting Group</strong>
                                </template>
                                <b-icon icon="menu-down"></b-icon>
                            </button>

                            <b-dropdown-item
                                v-for="(grp,grpIdx) in allRepGroups"
                                v-bind:key="grpIdx"
                                v-bind:value="grp.reportingGroup"
                                v-on:click="selectGroup(grp)">
                                <h4>{{grp.reportingGroup}}</h4>
                            </b-dropdown-item>

                            <hr class="dropdown-divider">

                            <b-dropdown-item
                                v-bind:value="'All'"
                                v-on:click="selectGroup('All')">
                                <h4>All Reporting Group</h4>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>

                <div v-if="!globalLoading">
                    <div class="section no-padd--top reporting-group-section"
                        v-for="(grpData,grpIdx) in groupStatusBreakdown"
                        v-bind:key="grpIdx">

                        <p class="title is-4">{{grpData.reportingGroup}}</p>

                        <div class="columns is-mobile is-multiline">

                            <div class="column is-one-third">

                                <div class="content">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th class="has-text-centered">Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(status,statusIdx) in grpData.statusBreakdown"
                                                v-bind:key="statusIdx">
                                                <td>
                                                    <span class="tag"
                                                        v-bind:class="'tag--'+statusIdx">{{status.validationCardStatus}}</span>
                                                </td>
                                                <td class="has-text-centered has-text-weight-semibold">
                                                    <a 
                                                        class="button is-text"
                                                        v-on:click="viewEntitiesUnits(grpData,status)">
                                                        {{status.count}}
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="column" >
                                <div class="content">
                                    <!-- Search entity and show (count) per page -->
                                    <div class="columns"
                                        v-if="grpData.topData.length > 5">
                                        <div class="column">
                                            <b-field 
                                                grouped 
                                                group-multiline>
                                                <div class="control is-flex">
                                                    <b-field>
                                                        <b-input 
                                                            placeholder="Search Entity/Unit"
                                                            type="search"
                                                            icon="magnify"
                                                            v-model="grpData.entityUnitSearchKeyword">
                                                        </b-input>
                                                    </b-field>
                                                </div>
                                            </b-field>
                                        </div>
                                        <div class="column is-2 has-text-right">
                                            <b-select 
                                                v-model="grpData.perPage">
                                                <option :value="5">5 per page</option>
                                                <option :value="10">10 per page</option>
                                                <option :value="15">15 per page</option>
                                                <option :value="20">20 per page</option>
                                            </b-select>
                                        </div>
                                    </div>
                                    
                                    <!-- Table -->
                                    <b-table
                                        v-bind:data="searchResults(grpData)"
                                        v-bind:paginated="true"
                                        v-bind:per-page="grpData.perPage"
                                        v-bind:pagination-simple="true"
                                        aria-next-label="Next page"
                                        aria-previous-label="Previous page"
                                        aria-page-label="Page"
                                        aria-current-label="Current page">

                                        <template slot-scope="props">

                                            <b-table-column 
                                                field="completionPercentage"
                                                :sortable="true"
                                                label="Completed Forms"
                                                :centered="true"
                                                width="10%">
                                                <p class="tag"
                                                    v-bind:class="{
                                                        'is-success':props.row.completionPercentage==100,
                                                        'is-light':props.row.completionPercentage<100
                                                    }"
                                                    v-if="props.row.validationCardStatus=='No Data Entry'">
                                                    {{props.row.completedForms}} / {{props.row.numForms}}
                                                </p>
                                                <a class="tag"
                                                    v-bind:class="{
                                                        'is-success':props.row.completionPercentage==100,
                                                        'is-light':props.row.completionPercentage<100
                                                    }"
                                                    v-if="props.row.validationCardStatus!='No Data Entry'"
                                                    v-bind:href="'#/preview-workspace?validationCardId='+props.row.validationCardId+'&reportingYear='+selectedReportingYear">
                                                    {{props.row.completedForms}} / {{props.row.numForms}}
                                                </a>
                                            </b-table-column>

                                            <b-table-column 
                                                label="Entity/Unit"
                                                field="entityUnitLabel"
                                                :searchable="true"
                                                width="65%">
                                                <span 
                                                    v-if="props.row.validationCardStatus=='No Data Entry'">
                                                    {{props.row.entityUnitLabel}}
                                                </span>
                                                <a v-if="props.row.validationCardStatus!='No Data Entry'"
                                                    v-bind:href="'#/preview-workspace?validationCardId='+props.row.validationCardId+'&reportingYear='+selectedReportingYear">
                                                    {{props.row.entityUnitLabel}}
                                                </a>
                                            </b-table-column>

                                            <b-table-column 
                                                label="Validation Status"
                                                width="10%">
                                                <span class="tag"
                                                    v-bind:class="'tag--'+props.row.validationCardStatusClass">{{props.row.validationCardStatus}}</span>
                                            </b-table-column>

                                        </template>

                                        <template slot="empty">
                                            <section class="section">
                                                <div class="content has-text-grey has-text-centered">
                                                    <p>
                                                        <b-icon
                                                            pack="fas"
                                                            icon="box-open"
                                                            size="is-large">
                                                        </b-icon>
                                                    </p>
                                                    <p>No data available.</p>
                                                </div>
                                            </section>
                                        </template>
                                    </b-table>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </section>

        <!-- Empty State -->
        <section class="section no-padd--top app-view"
            v-if="showGetStarted && !isLoading">
            <div
                class="has-text-centered empty-state-box empty-state-box--white padd-top--lrg" >
                <div class="has-text-centered"
                    v-if="!validationPeriod">
                    <p class="title is-5">Validation period has not started yet for the selected reporting year ({{selectedReportingYear}}).</p>
                </div>

                <div class="has-text-centered"
                    v-if="validationPeriod && validationPeriod.vPeriodStatus!=='Closed'"> 
                    <p class="title is-5"
                        v-if="vPeriodForms.length == 0">There are no forms created yet for the selected reporting year ({{selectedReportingYear}}).</p>
                </div>
            </div>   
        </section>

        <!-- Modal -->
        <b-modal
            v-bind:active.sync="openShowMoreModal"
            v-bind:width="650"
            v-on:close="closeExpandedView"
            scroll="keep">
            <div class="box base-box--padded ore-modal-box"
                v-if="selectedExpandedGroup!=null">
                
                <p class="heading">Reporting Group</p>
                <p class="title">{{selectedExpandedGroup.reportingGroup}}</p>

                <div class="content ore-modal-content">    
                    
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Entity/Unit</th>
                                <th class="has-text-centered">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(eu,euIdx) in filterByStatus"
                                v-bind:key="euIdx">
                                <td>
                                    {{eu.reportingUnit ? eu.reportingUnit : eu.reportingEntity }}
                                </td>
                                <td class="has-text-centered">
                                    <span class="tag"
                                        v-bind:class="'tag--'+eu.validationCardStatusClass">{{eu.validationCardStatus}}</span>
                                </td>
                            </tr>
                            <tr v-if="filterByStatus.length==0">
                                <td colspan="2" class="has-text-left">
                                    No data available.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-modal>

    </section>
</template>

<style scoped>
.reporting-group-section {
    border-bottom: 1px solid whitesmoke;
    margin-bottom: 1rem
}
.reporting-group-section .is-divider {
    padding: 0px;
    margin: 1.2rem;
}
.hero-metrics-box {
    border:1px solid rgb(219, 219, 219);
    border-radius: 6px;
    margin: 1.3rem;
    margin-top: 0em;
    margin-bottom: 1.85rem;
    padding: 1rem !important;
}
.vstatus-count-btn {
    visibility: hidden;
}
.vstatus-count:hover .vstatus-count-btn {
    visibility: visible;
}
section {
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/IAdminDashboardView.vue